import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "src/@/components/ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "src/@/components/ui/select";
import { Card, CardHeader, CardContent, CardFooter } from "src/@/components/ui/card";
import { Switch } from "src/@/components/ui/switch";
import { Label } from "src/@/components/ui/label";
import useAuth from "src/hooks/useAuth";
import getActionListaUsuariosByClienteId from "src/actions/usuarios/getActionListaUsuariosByClienteId";

const CardTransferCard = ({
  user,
  changeBlock,
  key,
  block,
  cardId,
  availableUsers,
  onCardTransferred
 }) => {
  const { t } = useTranslation('automation');
  const [users, setUsers] = useState([]);

  async function getUsers() {
    try {
      const response = await getActionListaUsuariosByClienteId(user.clienteId);
      setUsers(response.data.usuarios);

    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getUsers();
  }, []);

  const handleLinkToChatUserChange = (checked) => {
    let event = {
      name: "linkToChatUser",
      value: checked,
    }
    changeBlock(event)
  }

  return (
    <div className="w-full">
        <div className="space-y-4">
          {/* Switch para vincular ao usuário do chat */}
          <div className="flex items-center space-x-2">
            <Switch
              id="link-to-chat-user"
              checked={block?.data?.linkToChatUser || false}
              onCheckedChange={handleLinkToChatUserChange}
            />
            <Label htmlFor="link-to-chat-user" className="text-sm font-medium">
              {t('reactionCards.transferCard.linkToChatUserLabel', 'Vincular ao usuário do chat vinculado ao lead')}
            </Label>
          </div>

          {/* Seleção de Usuário - desabilitada quando linkToChatUser estiver ativo */}
          <div>
            <label className="block text-sm font-medium">{t('labels.user', { ns: 'common', defaultValue: 'Usuário' })}</label>
            <Select
              value={block?.data?.cardTransferUsers}
              onValueChange={(value) =>{
                let event = {
                  name: "cardTransferUsers",
                  value: value,
                }
                changeBlock(event)
              }}
              className="w-full"
              disabled={block?.data?.linkToChatUser}
            >
              <SelectTrigger className="w-full">
                <SelectValue placeholder={block?.data?.linkToChatUser ? t('reactionCards.transferCard.userAutoPlaceholder', 'Usuário será vinculado automaticamente') : t('reactionCards.transferCard.userPlaceholder', 'Selecione um usuário')} />
              </SelectTrigger>
              <SelectContent>
                {users?.map((user) => (
                  <SelectItem key={user._id} value={user._id}>
                    {user.nomeFantasia}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            {block?.data?.linkToChatUser && (
              <p className="text-xs text-muted-foreground mt-1">
                {t('reactionCards.transferCard.autoTransferHint', 'O lead será transferido automaticamente para o usuário responsável pelo chat')}
              </p>
            )}
          </div>
        </div>
    </div>
  );
};

export default CardTransferCard;
